import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import UserHasPermission, { modulesActions, userHasPermission } from "../../../roles/components/UserHasPermission";
import { connect } from 'react-redux';

const SubMenu = ({
    isOpen = false,
    menuOptions = [],
    headerLabel = "",
    activePath = "",
    onSubMenuHeaderClicked,
    userPermissions = []
}) => {

    //Check if at least one route is visible by the user
    let atLeastOneRouteIsVisible = false;
    for (let route of menuOptions) {
        if (userHasPermission(
            route.neededPermission,
            modulesActions.READ,
            userPermissions
        )) {
            atLeastOneRouteIsVisible = true;
            break;
        }
    }

    if (!atLeastOneRouteIsVisible) return null;

    const childIsSelected = menuOptions.findIndex(route => route.id === activePath) !== -1;

    return (
        <div className="sub-menu-parent ">
            <span
                className={"sub-menu-title " + (isOpen ? "isOpen" : childIsSelected ? "is-selected" : "")}
                onClick={onSubMenuHeaderClicked}
            >
                <span>
                    {I18n.t('routes.' + headerLabel)}
                </span>
                {isOpen ?
                    <FontAwesomeIcon icon={['fas', 'angle-up']} /> :
                    <FontAwesomeIcon icon={['fas', 'angle-down']} />
                }
            </span>
            <div
                className={
                    "open-menu-transition" + 
                    (isOpen ? " isOpen" : "")
                }
            >
                {menuOptions
                    .map(({
                        id: route,
                        neededPermission
                    }, index) => (
                            <UserHasPermission
                                appModule={neededPermission}
                                action={modulesActions.READ}
                                key={headerLabel + '_' + index}
                            >
                                <Link
                                    to={"/" + route}
                                    key={headerLabel + '_' + index}
                                    className={"sub-menu-child " + (isOpen ? "isOpen " : "") + (activePath === route ? "is-selected" : "")}
                                >
                                    {I18n.t('routes.' + route)}
                                </Link>
                            </UserHasPermission>
                        )
                    )}
            </div>

        </div>
    );
};

SubMenu.propTypes = {
    isOpen: PropTypes.bool,
    headerLabel: PropTypes.string,
    activePath: PropTypes.string,
    onSubMenuHeaderClicked: PropTypes.func.isRequired,
    menuOptions: PropTypes.PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = ({ authReducer }) => ({
    userPermissions: authReducer.user && authReducer.user.role ? authReducer.user.role.permissions : []
   
});

export default connect(
    mapStateToProps,
    null
)(SubMenu);